import { FrequencyUnit, HabitSchedule } from '@griply/types';

import { Frequency, RRule } from './lib/rrule';

export const getScheduleFrequency = (schedule: HabitSchedule) => {
  if (schedule.frequency) {
    return schedule.frequency.unit;
  }

  const rrule = RRule.fromString(schedule.rrule.format);
  switch (rrule.options.freq) {
    case Frequency.YEARLY:
      return FrequencyUnit.Year;
    case Frequency.MONTHLY:
      return FrequencyUnit.Month;
    default:
      return FrequencyUnit.Week;
  }
};
